import React from 'react'
import './../assest/style/Home.css'
import jojo from './../assest/images/Home/jojo.jpg'
import { Container } from 'react-bootstrap'
import resume from './../assest/images/Home/resume.pdf'

export const Home = () => {
  return (
    <div className='Home'>
<Container>
    <div className='row'>
    <div className='col-lg-6 col-md-12 col-sm-12 box'>
       
       <img src={jojo}/>
      
            </div>
        <div className='col-lg-6 col-md-12 col-sm-12 box2'>
        <h5> Digital creative professional</h5>
            
            <div className="content">
    <h2>Jaafar Ahmad</h2>
    <h2>Jaafar Ahmad</h2>
  </div>
  <br/>
           
          
        <h6>
        I'm a digital marketer with 7 years of experience and a graphic designer for 3 years. I've crafted successful digital campaigns, amplifying brand presence online. My design journey enhances my ability to create visually impactful content, merging my skills for strategic and engaging results. Dedicated to innovation, I thrive on combining design and digital marketing for lasting impact.
        </h6>
        <button> <a href={resume} download="resume">Download CV </a> </button>
        <div className='icon'>
        <a href='https://www.facebook.com/jaafar.digitalmarketing?mibextid=ZbWKwL'><i className="fa-brands fa-facebook-f" style={{color: "#7d26cd" ,borderRadius: "50%",border: "2px solid #7d26cd",padding: "15px 15px",marginRight:"20px"}}></i></a>
       <a href='https://instagram.com/jaafar.homam.ahmad?igshid=NGVhN2U2NjQ0Yg=='><i className="fa-brands fa-instagram" style={{color: "#7d26cd" ,borderRadius: "50%",border: "2px solid #7d26cd",padding: "15px 15px",marginRight:"20px"}}></i></a>
       <a href='https://www.linkedin.com/in/jaafar-ahmad-92333824a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'><i className="fa-brands fa-linkedin-in" style={{color: "#7d26cd" ,borderRadius: "50%",border: "2px solid #7d26cd",padding: "15px 15px"}}></i></a>
       </div>
        </div>
      
    </div>
</Container>
    </div>
  )
}
